module.exports = __webpack_public_path__ + "img/productions_24.33421211.png";